import type React from "react";

export interface IUserData {
  email: string;
  password: string;
  password2: string;
  phone: string;
  company: string;
  city: string;
  legal: boolean;
}

export const initialUserData: IUserData = {
  email: "",
  password: "",
  password2: "",
  phone: "",
  company: "",
  city: "",
  legal: false,
};

export type SignUpFieldProps = {
  userData: IUserData;
  setUserData: React.Dispatch<React.SetStateAction<IUserData>>;
};
